import { render } from "./Seraphim.vue?vue&type=template&id=36f90bb9&scoped=true"
import script from "./Seraphim.vue?vue&type=script&lang=js"
export * from "./Seraphim.vue?vue&type=script&lang=js"

import "./Seraphim.vue?vue&type=style&index=0&id=36f90bb9&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36f90bb9"]])

export default __exports__